document.addEventListener("DOMContentLoaded", function () {
  console.log("article-swiper-slider.js loaded");

  new Swiper(".shortcode-collection__swiper", {
    slidesPerView: "auto",
    loop: false,

    freeMode: {
      enabled: true,
      momentum: true,
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
